<template>
  <div>
    <span v-html="textoMostrar"></span>
    <a class="grey--text text--darken-2 font-weight-bold" v-if="tipo === 'corto' && cambio && texto.length > 80" @click="verMas()">
      <span>...Ver más&nbsp;&gt;</span>
    </a>
    <a class="grey--text text--darken-2 font-weight-bold" v-if="!cambio && texto.length > 80" @click="verMenos()">
      <span>...&lt;&nbsp;Ver menos</span>
    </a>
  </div>
</template>

<script>

export default {
  name: 'text-extendible',
  props: {
    texto: {
      type: String,
      default: 'help'
    },
    tipo: {
      type: String,
      default: 'corto'
    }
  },
  data: () => ({
    textoMostrar: '',
    cambio: false
  }),
  mounted () {
    if (this.texto) {
      this.textoMostrar = this.texto;
      if (this.tipo === 'corto' && this.texto.length > 80) {
        this.cambio = true;
        this.textoMostrar = this.texto.substring(0, 80);
      }
    }
  },
  methods: {
    verMas () {
      this.textoMostrar = this.texto;
      this.cambio = !this.cambio;
    },
    verMenos () {
      this.textoMostrar = this.texto.substring(0, 80);
      this.cambio = !this.cambio;
    }
  },
  watch: {
    texto () {
      this.textoMostrar = this.texto;
      if (this.tipo === 'corto' && this.texto.length > 80) {
        this.cambio = true;
        this.textoMostrar = this.texto.substring(0, 80);
      }
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/common/util/TextExtendible.vue